import {fetchPost, generateEndpoint} from "../../../utils/request";

export const createBsrsFollowUp = async({ name, telephone, pressureEvent }) => {
  const url = `${generateEndpoint('createBsrsFollowUp')}`
  return fetchPost(url, null, { name, telephone, pressureEvent })
}